function path(root, sublink) {
  return `${root}${sublink}`;
}

export const ADMIN_ROOT = ``;

export const ROUTES = {
  root: "/",
  page404: path(ADMIN_ROOT, "/404"),
  page500: path(ADMIN_ROOT, "/500"),
  auth: {
    login: path(ADMIN_ROOT, "/login"),
  },
  general: {
    welcome: path(ADMIN_ROOT, "/welcome"),
  },
  order: {
    root: path(ADMIN_ROOT, "/order"),
    list: path(ADMIN_ROOT, "/order/list"),
  },
  price: {
    root: path(ADMIN_ROOT, "/price"),
    coupon: {
      root: path(ADMIN_ROOT, "/price/coupon"),
      new: path(ADMIN_ROOT, "/price/coupon/new"),
      list: path(ADMIN_ROOT, "/price/coupon/list"),
    },
    discount: {
      root: path(ADMIN_ROOT, "/price/discount"),
      new: path(ADMIN_ROOT, "/price/discount/new"),
      list: path(ADMIN_ROOT, "/price/discount/list"),
    },
  },
  special_offer: {
    root: path(ADMIN_ROOT, "/special-offer"),
    list: path(ADMIN_ROOT, "/special-offer/list"),
    new: path(ADMIN_ROOT, "/special-offer/new"),
  },
  product: {
    root: path(ADMIN_ROOT, "/product"),
    list: path(ADMIN_ROOT, "/product/list"),
    new: path(ADMIN_ROOT, "/product/new"),
    productById: path(ADMIN_ROOT, "/product/:id"),
    editById: path(ADMIN_ROOT, "/product/:id/edit"),
  },
  user: {
    root: path(ADMIN_ROOT, "/user"),
    list: path(ADMIN_ROOT, "/user/list"),
    new: path(ADMIN_ROOT, "/user/new"),
    showById: path(ADMIN_ROOT, "/user/:id"),
    editById: path(ADMIN_ROOT, "/user/:id/edit"),
  },
  location: {
    root: path(ADMIN_ROOT, "/location"),
    list: path(ADMIN_ROOT, "/location/list"),
    new: path(ADMIN_ROOT, "/location/new"),
    showById: path(ADMIN_ROOT, "/location/:id"),
    editById: path(ADMIN_ROOT, "/location/:id"),
  },
  color: {
    root: path(ADMIN_ROOT, "/color"),
    list: path(ADMIN_ROOT, "/color/list"),
    new: path(ADMIN_ROOT, "/color/new"),
    showById: path(ADMIN_ROOT, "/color/:id"),
    editById: path(ADMIN_ROOT, "/color/:id"),
  },
  category: {
    root: path(ADMIN_ROOT, "/category"),
    list: path(ADMIN_ROOT, "/category/list"),
    new: path(ADMIN_ROOT, "/category/new"),
    showById: path(ADMIN_ROOT, "/category/:id"),
    editById: path(ADMIN_ROOT, "/category/:id"),
  },
  page: {
    root: path(ADMIN_ROOT, "/page"),
    list: path(ADMIN_ROOT, "/page/list"),
    new: path(ADMIN_ROOT, "/page/new"),
    showById: path(ADMIN_ROOT, "/page/:id"),
    editById: path(ADMIN_ROOT, "/page/:id"),
  },
  customer: {
    root: path(ADMIN_ROOT, "/customer"),
    all: path(ADMIN_ROOT, "/customer/all"),
    withPurchases: path(ADMIN_ROOT, "/customer/with-purchases"),
    showById: path(ADMIN_ROOT, "/customer/:id"),
    editById: path(ADMIN_ROOT, "/customer/:id"),
  },
};
